import { useLocalSearchParams } from 'expo-router'

import { WizardScreen } from '@/src/features/settings/ui/screens/WizardScreen'
import type { TSourceParam } from '@/src/general/constants/routes'
import { filterSearchParams } from '@/src/general/utils/filterSearchParams'

export default () => {
  const searchParams = useLocalSearchParams()
  const { source } = filterSearchParams<TSourceParam>(searchParams)

  return <WizardScreen source={source} />
}
